(function (window, document) {

    const quoteContainers = document.querySelectorAll('.quote-hdo-container');

    if (quoteContainers) {
        /**
         * Add or remove the css-class-selector if the quote element has a specific width
         * @param quoteContainer
         * @param size
         */
        const updateSizeOfQuote = (quoteContainer, size) => {
            if (quoteContainer !== null) {
                if (quoteContainer.dataset.quoteLayout === 'full-width') {
                    if (size > window.viewportRanges.lg) {
                        quoteContainer.classList.add('quote-full-width');
                    }
                    else {
                        quoteContainer.classList.remove('quote-full-width');
                    }
                }
            }
        };

        Array.from(quoteContainers).forEach(quoteContainer => {
            let size;
            let resizeObserver = new ResizeObserver(entries => {
                for (let entry of entries) {
                    if (entry.contentBoxSize) {
                        const contentBoxSize = Array.isArray(entry.contentBoxSize) ? entry.contentBoxSize[0] : entry.contentBoxSize;

                        size = contentBoxSize.inlineSize;
                    } else {
                        size = entry.contentRect.width;
                    }
                }

                updateSizeOfQuote(quoteContainer, size);
            });

            resizeObserver.observe(quoteContainer);
        });
    }
})(window, document);
